import { TemplateResult } from 'lit';

export interface TimelineItem {
  id: string;
  label: string;
  details?: string;
  isEmphasized?: boolean;
  groupedEntriesCount?: number;
  contentRenderer?: (item: any) => TemplateResult | undefined;
  suffixRenderer?: (item: any) => TemplateResult | undefined;
}

export interface TimelineGroup {
  id: string;
  label?: string;
  isCategory?: boolean;
  items: TimelineItem[];
}

export type TimelineData = TimelineItem[] | TimelineGroup[];

export enum TimelineEvent {
  TOGGLE_ITEM = 'toggleItem',
  TOGGLE_ITEM_IN_GROUP = 'toggleItemInGroup',
  TOGGLE_PANEL = 'togglePanel',
  SLOT_HEADER_CLICK = 'slotHeaderClick',
}

type Additional = 'ALERT_NAME_GROUP';
export type AdditionalData = Record<Additional, any>;
